import PersonalizedInsights from "../assets/sell/personalized-insights-pic.svg";
import RealtionShipAdvice from "../assets/sell/relationship-advice-pic.svg";
import GrowthOpportunities from "../assets/sell/growth-opportunities-pic.svg";
import CommunitySupport from "../assets/sell/community-support-pic.svg";
import CareerGuidence from "../assets/sell/career-guidence-pic.svg";

export const ASSESSMENT_TYPES = {
  DEFAULT: "DEFAULT",
  CAREER_PREFERENCE: "CAREER_PREFERENCE",
  ROMANTIC_COMPATIBILITY: "ROMANTIC_COMPATIBILITY",
  COLOR_BLIND: "COLOR_BLIND",
  DEPRESSION: "DEPRESSION",
  BIPOLAR: "BIPOLAR",
  PSYCHOPATH: "PSYCHOPATH",
  CHILDHOOD_TRAUMA: "CHILDHOOD_TRAUMA",
  SOCIAL_ANXIETY: "SOCIAL_ANXIETY",
  AUTISM_CHILDREN: "AUTISM_CHILDREN",
  SOCIOPATH: "SOCIOPATH",
};

export const IMAGE_MAP = {
  PersonalizedInsights,
  GrowthOpportunities,
  CareerGuidence,
  CommunitySupport,
  RealtionShipAdvice,
};

export const MONEY_BACK_GUARANTEE = [
  {
    title: "plan.feature.money_back_guarantee",
    image: "CommunitySupport",
  },
];

export const ACCESS_ALL_TEST = [
  {
    title: "plan.feature.all_tests_access",
    image: "RealtionShipAdvice",
  },
];

export const SHARE_AND_COMPARE_RESULT = [
  {
    title: "plan.feature.share_compare_results",
    image: "CareerGuidence",
  },
];

export const SHARE_AND_COMPARE_RESULT_DEFAULT = [
  {
    title: "plan.plan_feature_share_results",
    image: "CareerGuidence",
  },
];

export const ASSESSMENT_PLAN_CONFIG = {
  [ASSESSMENT_TYPES.DEFAULT]: {
    primaryFeature: [
      {
        title: "plan.plan_feature_complete_report",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.relationship_career_insights",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.CAREER_PREFERENCE]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "CareerGuidence",
      },
    ],
    extraFeatures: [
      {
        title: "plan.plan_feature_career_insights",
        image: "CareerGuidence",
      },
    ],
  },

  [ASSESSMENT_TYPES.ROMANTIC_COMPATIBILITY]: {
    primaryFeature: [
      {
        title: "plan.plan_feature_comprehensive_report",
        image: "RealtionShipAdvice",
      },
    ],
    extraFeatures: [
      {
        title: "plan.plan_feature_relationship_insights",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.COLOR_BLIND]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.colorblind_plan_feature",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.DEPRESSION]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.discover_depression_level",
        image: "CareerGuidence",
      },
    ],
  },

  [ASSESSMENT_TYPES.BIPOLAR]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.discover_bipolar_likelihood",
        image: "CareerGuidence",
      },
    ],
  },

  [ASSESSMENT_TYPES.PSYCHOPATH]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "GrowthOpportunities",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.psychopathy_insights",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.CHILDHOOD_TRAUMA]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "GrowthOpportunities",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.childhood_insights",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.SOCIAL_ANXIETY]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.social_anxiety",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.AUTISM_CHILDREN]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.autism_children",
        image: "GrowthOpportunities",
      },
    ],
  },

  [ASSESSMENT_TYPES.SOCIOPATH]: {
    primaryFeature: [
      {
        title: "plan.feature.comprehensive_assessment",
        image: "PersonalizedInsights",
      },
    ],
    extraFeatures: [
      {
        title: "plan.feature.sociopathy_insights",
        image: "GrowthOpportunities",
      },
    ],
  },
};

const ASSESSMENT_TYPE_MAP = [
  ["isCareerPreferenceTest", ASSESSMENT_TYPES.CAREER_PREFERENCE],
  ["isRomanticCompatibilityTest", ASSESSMENT_TYPES.ROMANTIC_COMPATIBILITY],
  ["isColorBlindTest", ASSESSMENT_TYPES.COLOR_BLIND],
  ["isDepressionTest", ASSESSMENT_TYPES.DEPRESSION],
  ["isBipolarTest", ASSESSMENT_TYPES.BIPOLAR],
  ["isPsychopathTest", ASSESSMENT_TYPES.PSYCHOPATH],
  ["isChildhood_Trauma", ASSESSMENT_TYPES.CHILDHOOD_TRAUMA],
  ["isSocialAnxietyTest", ASSESSMENT_TYPES.SOCIAL_ANXIETY],
  ["isAutismChildrenTest", ASSESSMENT_TYPES.AUTISM_CHILDREN],
  ["isSociopathTest", ASSESSMENT_TYPES.SOCIOPATH],
];

export const getAssessmentPlanType = (flags) => {
  const matchedType = ASSESSMENT_TYPE_MAP.find(([key]) => flags[key]);
  return matchedType?.[1] || ASSESSMENT_TYPES.DEFAULT;
};

export const createPlanFeature = ({ title, image, t, description }) => ({
  title: t(title),
  image: IMAGE_MAP[image],
  description: description || t(title),
});

export const generatePlanFeatures = ({
  scheduleTypeCD,
  selectedAssessment,
  inviteFeature,
  assessmentType,
  t,
}) => {
  const isPsychopathTest = ASSESSMENT_TYPES.PSYCHOPATH === assessmentType;
  const isSociopathTest = ASSESSMENT_TYPES.SOCIOPATH === assessmentType;
  const isChildhood_Trauma =
    ASSESSMENT_TYPES.CHILDHOOD_TRAUMA === assessmentType;

  const featureGroups = [
    // Yearly-only features
    scheduleTypeCD === "YEAR"
      ? [
          {
            title: "plan.feature.annual_savings",
            image: "PersonalizedInsights",
          },
        ]
      : [],

    // Primary feature
    selectedAssessment.primaryFeature,

    // Extra features from assessment
    selectedAssessment.extraFeatures,

    // Standard feature groups
    MONEY_BACK_GUARANTEE,

    // Psychopath/Sociopath tests → access all tests, then invite first
    isPsychopathTest || isSociopathTest
      ? [...ACCESS_ALL_TEST, ...(inviteFeature ? [inviteFeature] : [])]
      : [...(inviteFeature ? [inviteFeature] : []), ...ACCESS_ALL_TEST],

    // Share and compare features
    assessmentType === "DEFAULT"
      ? SHARE_AND_COMPARE_RESULT_DEFAULT
      : SHARE_AND_COMPARE_RESULT,
  ];

  return featureGroups
    .flat()
    .filter(Boolean)
    .map((feature) => createPlanFeature({ ...feature, t }));
};
